/**
 * Handles image upload and preview functionality
 * @module imageUploader
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'imageUploader';
export const DEFAULTS = {
  uploadButton: '.js-trigger-upload-btn',
  fileInput: '#js-image-upload-target',
  previewImage: '.js-preview-img',
  removeButton: '.js-remove-img',
  imagePlaceholder: '.js-image-upload-ph',
  dropzone: '.js-dropzone',
};

/**
 * Handles the image preview functionality.
 * @param  {Object} opts - The options provided by the user or defaults.
 */

const previewImage = (file, opts) => {
  const $previewImg = $(opts.previewImage);
  const $removeImgBtn = $(opts.removeButton);
  const $imgPlaceholder = $(opts.imagePlaceholder);

  if (file) {
    window.uploadedImage = file;
    window.updatedImage = true;
    const reader = new FileReader();
    reader.onload = (e) => {
      $previewImg.attr('src', e.target.result);
      $previewImg.show();
      $removeImgBtn.removeClass('u-hide');
      $imgPlaceholder.hide();
    };
    reader.readAsDataURL(file);
  }
};
const handleImageUpload = (opts) => {
  const $fileInput = $(opts.fileInput);

  $fileInput.on('change', (event) => {
    const file = event.target.files[0];
    previewImage(file, opts);
  });
};

const handleDragAndDrop = (opts) => {
  const $dropzone = $(opts.dropzone);

  $dropzone.on('dragover', (e) => {
    e.preventDefault();
    $dropzone.addClass('drag-over');
  });

  $dropzone.on('dragleave', () => {
    $dropzone.removeClass('drag-over');
  });

  $dropzone.on('drop', (e) => {
    e.preventDefault();
    $dropzone.removeClass('drag-over');
    const file = e.originalEvent.dataTransfer.files[0]; // Get the dropped file
    previewImage(file, opts); // Preview the dropped image
    const $fileInput = $(opts.fileInput);
    $fileInput.prop('files', e.originalEvent.dataTransfer.files);
  });
};

/**
 * Handles image removal functionality.
 * @param  {Object} opts - The options provided by the user or defaults.
 */
const handleImageRemove = (opts) => {
  const $fileInput = $(opts.fileInput);
  const $previewImg = $(opts.previewImage);
  const $removeImgBtn = $(opts.removeButton);
  const $imgPlaceholder = $(opts.imagePlaceholder);


  $removeImgBtn.on('click', function removeImageButton() {
    $fileInput.val('');
    $previewImg.attr('src', '#').hide();
    $imgPlaceholder.show();
    $(this).hide();
    window.uploadedImage = null;
    window.updatedImage = true;
  });
};

/**
 * Initializes the image uploader plugin.
 * @param {HTMLElement} el - The form element or container triggering the upload
 * @param {Object} options - Options for configuring the image uploader
 * @see DEFAULTS
 */
export default function imageUploader(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);

  const $uploadButton = $(opts.uploadButton);
  const $fileInput = $(opts.fileInput);

  // When the "Upload Image" button is clicked, trigger the file input
  $uploadButton.on('click', (e) => {
    e.preventDefault();
    $fileInput.trigger('click');
  });

  // Set up the handlers for image upload and remove
  handleImageUpload(opts);
  handleDragAndDrop(opts);
  handleImageRemove(opts);
}

// Register the plugin with jQuery
registerJQueryPlugin(PLUGIN_NAME, imageUploader);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/image-upload.js